// @ts-nocheck

import React, { useState, useEffect, useCallback } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { CheckboxProps } from "./Checkbox.props";
import styles from "./Checkbox.module.scss";

/**
 * @deprecated
 */
export const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps): JSX.Element => {
  const { id, handleOnChange, name, disabled, value, selected = false, isLoading, containerClassName } = props;
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    setChecked(selected);
  }, [selected]);

  const checkboxWrapperClass = cn(styles["checkbox"], { [styles["checkbox-disabled"]]: disabled });

  const checkboxContainerClass = cn(styles["checkbox-container"], containerClassName);

  const handleInputChange = useCallback(
    (ev: React.ChangeEvent<HTMLInputElement>): void => {
      setChecked(ev.target.checked);
      handleOnChange && handleOnChange(ev);
    },
    [handleOnChange],
  );

  const checkboxIndicator = cn(styles["checkbox-checkmark"]);

  let component = null;

  if (isLoading) {
    component = <Skeleton height={20} width={150} />;
  } else {
    component = (
      <label id={`checkbox-label-${id}`} className={checkboxWrapperClass}>
        <input
          name={name}
          aria-label="table checkbox"
          id={id}
          data-testid={`test__${id}`}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={(e): void => handleInputChange(e)}
          value={value}
        />
        <span data-testid={`test__checkbox-${id}`} className={checkboxIndicator}></span>
      </label>
    );
  }

  return <div className={checkboxContainerClass}>{component}</div>;
};

/**
 * @deprecated
 */
export default Checkbox;
